import Vue from 'vue'
import axios from 'axios';
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import vueSmoothScroll from 'vue2-smooth-scroll'
import VueMeta from 'vue-meta'

import router from './router'
import App from './App.vue'

import { directive as onClickOutside } from 'vue-on-click-outside'

import strings from './content/strings';

Vue.config.productionTip = false;

window.appLang = document.getElementsByTagName('html')[0].getAttribute('lang');

/**
 * apiRequestTimer
 * @type {Boolean}
 *
 * This variable is meant to hold the API request timer that is used in the
 * LocalInsights.vue component. We're using a global
 */
window.apiRequestTimer = false;

if ( ! window.ccode ) {
  window.ccode = 'CCODE';
}

Vue.use(VueCookies)
Vue.use(VueAxios, axios);
Vue.use(vueSmoothScroll);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

Vue.directive('on-click-outside', onClickOutside)
Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
});

/**
 * Set up the mixins that should be available to all the Vue components.
 */
Vue.mixin({

  computed: {

    getRoute: function() {

      var r = 'ini';
      if ( this.$route.matched[0] ){
        r = this.$route.matched[0].name;
      }

      return r;

    },

    doLocal: function() {
      if ( window.doLocal === undefined ) {
        window.doLocal = true;
      }
      return window.doLocal
    },

    localNotice: function() {
      if (window.localNotice === undefined) {
        window.localNotice = false;
      }
      return window.localNotice
    },

    isReport: function() {

      if ( this.doLocal ) {
        return ( this.getRoute === 'report' );
      } else {
        return true;
      }

    },

    isMobile: function() {

      var width = this.$root.$data.windowWidth;
      return width < 768;

    },

    isTablet: function() {

      var width = this.$root.$data.windowWidth;
      return width < 1024;

    },

    isLaptop: function() {

      var width = this.$root.$data.windowWidth;
      return width < 1200;

    },

    isDev: function() {
      return ! window.langSwitch;
    },

    calculatePercentage: function() {
      return this.$root.cPercentage;
    }

  },

  methods: {

    goto(id) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth"
      });
    },

    gotoElement: function (container, elm, duration) {
      let getRelativePos = function(elm) {
        var pPos = elm.parentNode.getBoundingClientRect(), // parent pos
          cPos = elm.getBoundingClientRect(), // target pos
          pos = {};

        pos.top = cPos.top - pPos.top + elm.parentNode.scrollTop,
          pos.right = cPos.right - pPos.right,
          pos.bottom = cPos.bottom - pPos.bottom,
          pos.left = cPos.left - pPos.left;

        return pos;
      }

      let scrollTo = function(element, to, duration, onDone) {
        var start = element.scrollTop,
          change = to - start,
          startTime = performance.now(),
          val, now, elapsed, t;

        function animateScroll() {
          now = performance.now();
          elapsed = (now - startTime) / 1000;
          t = (elapsed / duration);

          console.log(start + change * easeInOutQuad(t));
          element.scrollTop = start + change * easeInOutQuad(t);

          if (t < 1)
            window.requestAnimationFrame(animateScroll);
          else
            onDone && onDone();
        };

        animateScroll();
      }

      let easeInOutQuad = function(t) { return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t };

      var pos = getRelativePos(elm);
      scrollTo(container, pos.top, .75);  // duration in seconds

    },

    thousandSeparators: function(x) {
      var lang = window.appLang;
      if ( lang === 'fr' ) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      } else {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },

    formatCurrency: function(number, dec = 0, cleanDec = true) {

      var lang = window.appLang,
        symbol = (lang === 'fr') ? '&nbsp;$' : '$';
        
      number = Number(number);

      var string_number = number.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      if (lang === 'fr') {
        string_number = string_number.replaceAll(',',' ').replaceAll('.', ',') + symbol;
      } else {
        string_number = symbol + string_number
      }
      
      return string_number;
      
    },

    formatPercentage: function(number, dec = 0, cleanDec = true, approximate = false) {

      var lang = window.appLang,
          symbol = ( lang === 'fr' ) ? '&nbsp;%' : '%';

      if ( dec === 1 && number < .001 ) {
        dec = 2;
      }

      number = Number(number);
      number *= 100;

      var string_number = number.toFixed(dec);

      if ( lang === 'fr' ) {
        string_number = string_number.replace('.', ',');
      }

      if ( approximate ) {

        if ( number.toFixed(dec) > 0 ) {

          return '~' + string_number + symbol;

        }

      }

      if ( cleanDec ) {
        if ( lang === 'fr' ) {
          string_number = string_number.replace(/(\,[0-9]*?)0+$/, "$1"); // remove trailing zeros
          string_number = string_number.replace(/\,$/, "");              // remove trailing dot
        } else {
          string_number = string_number.replace(/(\.[0-9]*?)0+$/, "$1"); // remove trailing zeros
          string_number = string_number.replace(/\.$/, "");              // remove trailing dot
        }
      }

      return string_number + symbol;

    },

    apiLabel: function(label, translate = true) {

      if ( translate !== 'false' && translate !== false) {
        let key = label.toLowerCase().replaceAll(' / ', '_').replaceAll('/', '_').replaceAll(' ', '_');
        let translated = this._translate(key);

        if ( translated !== '[undefined string]') {
          return translated;
        }
      }

      if ( label.substr(0,1) === '_' ) {
        label = label.substr(1);
      }

      label = label.replaceAll('_', ' ');

      return label;

    },

    getSection: function() {

      if ( ! this.doLocal ) {
        return 'report';
      }

      if ( this.$route.matched[0] ) {
        return (this.$route.matched[0].name === 'report') ? 'report' : 'local';
      }

      return false;

    },

    /**
     * FUNCTION: _translate
     * @param  {string} key - this is used to identify the string
     * @return {string} the string to be used
     *
     * This function is used to fetch the desired string from the translation table.
     * It also checks to determine if there is an active translation. If there is, it
     * attempts to return the translation.
     */
    _translate: function(key) {

      var lang = window.appLang;

      if ( ! strings.strings[key] ) {
        return '[undefined string]';
      }

      var s = strings.strings[key];

      var string = (s[lang]) ? s[lang] : s['en'] + ' [' + lang.toUpperCase() + ']';

      string = string.replace(new RegExp('®', 'g'), '<sup>®</sup>');

      const d = new Date();
      let year = window.staticYear ? window.staticYear : d.getFullYear();
      string = string.replace(new RegExp('@CY', 'g'), ((lang === 'fr' ? '&copy; ' : '&copy;') + year));

      return string;


    },


    /**
     * FUNCTION: _prints
     * @param  {string} string - this is the string to be checked for a substitution
     * @param  {string} s - this is the string that should replace any tokens (%s)
     * @return {string} the string with substitutions applied.
     *
     * This function is used to apply substitutions to strings through the use
     * of a token (%s). The idea is to be able to add dynamic application/client
     * data to strings that are used primarily as labels.
     */
    _prints: function(string, s) {
      return string.replace('%s', s);
    },

    iconSvg: function(key) {

      var icon = 'icon';

      return icon;

    }

  }

})

router.afterEach(( to, from ) => {
  if ( typeof window.dataLayer === "object" ) {
    dataLayer.push({'event':'vuePageView','pagePath': to.path});
  }
});

new Vue({
  router,
  render: h => h(App),

  mounted: function() {

    this.$nextTick(function() {

      window.addEventListener('resize', this.getWindowDimensions);

      //Init
      this.getWindowDimensions()

    })

  },

  data: function() {
    return {
      mobnav: false,
      windowWidth: 0,
      windowHeight: 0,
      windowBounce: false,
      cPercentage: false,
    }
  },

  methods: {

    getWindowDimensions(event) {
      
      if ( this.windowBounce ) { return false; }

      this.windowBounce = setTimeout(() => {
        this.windowWidth = document.documentElement.clientWidth;
        this.windowHeight = document.documentElement.clientHeight;
        this.windowBounce = false;
      }, 100);
    },

  },

}).$mount('#app');
